import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Stack = styled(Box).withConfig({
  componentId: "sc-1yd380u-0"
})(["display:flex;flex-direction:", ";margin:0;> *:not(:last-child){margin-right:", ";margin-bottom:", ";margin-left:", ";margin-top:", ";}"], function (_ref) {
  var orientation = _ref.orientation;

  switch (orientation) {
    case "vertical":
      return "column";

    case "horizontal-reverse":
      return "row-reverse";

    case "vertical-reverse":
      return "column-reverse";

    default:
      return "row";
  }
}, function (_ref2) {
  var _ref2$gutter = _ref2.gutter,
      gutter = _ref2$gutter === void 0 ? "md" : _ref2$gutter,
      orientation = _ref2.orientation;
  return orientation === "horizontal" && spacing(gutter);
}, function (_ref3) {
  var _ref3$gutter = _ref3.gutter,
      gutter = _ref3$gutter === void 0 ? "md" : _ref3$gutter,
      orientation = _ref3.orientation;
  return orientation === "vertical" && spacing(gutter);
}, function (_ref4) {
  var _ref4$gutter = _ref4.gutter,
      gutter = _ref4$gutter === void 0 ? "md" : _ref4$gutter,
      orientation = _ref4.orientation;
  return orientation === "horizontal-reverse" && spacing(gutter);
}, function (_ref5) {
  var _ref5$gutter = _ref5.gutter,
      gutter = _ref5$gutter === void 0 ? "md" : _ref5$gutter,
      orientation = _ref5.orientation;
  return orientation === "vertical-reverse" && spacing(gutter);
});
export { Stack };